/**
 * Enrollment Steps: backend steps list
 *
 * @param {*} tokena
 * @returns
 */
export async function getEnrollmentSteps(tokena) {
  return fetch('/connect/enrollment/steps', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      tokena,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    }

    // Wrong access credentials
    throw new Error('login.error_token');
  });
}
